import http from '../../services/http';

export default {
  init(instance) {
    document.addEventListener('alpine:init', () => {
      instance.data('hubspotForm', (csrfToken, formAction) => ({
        email: '',
        csrfToken,
        formAction,
        showMessage: false,
        message: '',
        success: false,

        async submitForm() {
          try {
            const response = await http.post(this.formAction, {
              email: this.email,
            }, {
              headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': this.csrfToken,
              },
            });

            if (response.status === 200) {
              this.displayMessage('Submission successful!', true);
            } else {
              console.error('Error:', response.statusText);
              this.displayMessage('Submission failed. Please try again.', false);
            }
          } catch (error) {
            console.error('Error during submission:', error);
            this.displayMessage('An error occurred during submission.', false);
          }
        },

        displayMessage(text, isSuccess) {
          this.message = text;
          this.success = isSuccess;
          this.showMessage = true;

          setTimeout(() => {
            this.showMessage = false;
          }, 5000);
        },
      }));
    });
  },
};
